import { HttpClient } from 'api/HttpClient';

import { ApplicationDto } from './ApplicationApi';

export interface UpdateBankAccountDto {
  applicationId: string;
  bankAccountNumber: string;
  bankAccountRoutingNumber: string;
}

export interface UpdateAutopayDto {
  applicationId: string;
  autopay: boolean;
}

export default class BankAccountsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/bankAccounts' || '');
  }

  public async updateBankAccount(updateBankAccountDto: UpdateBankAccountDto): Promise<ApplicationDto> {
    return this.instance.put(``, updateBankAccountDto).then((response) => response.data);
  }

  public async updateAutopay(updateAutopayDto: UpdateAutopayDto): Promise<ApplicationDto> {
    return this.instance.put('/autopay', updateAutopayDto).then((response) => response.data);
  }
}

export const bankAccountsApi = new BankAccountsApi();
